import React from "react";
import "./Pei_chart_holder.css";
import ReactApexChart from "react-apexcharts";
import { PieChart } from "@mui/x-charts/PieChart";

function Pei_chart_holder({EMITotal,principalTotal,interestTotal,loanValueTotal}) {
  const [state, setState] = React.useState({
    series: [42, 47, 52, 58, 65],
    options: {
      chart: {
        // width: 380,
        type: "pie",
      },
      labels: [
        "Category A",
        "Category B",
        "Category C",
        "Category D",
        "Category E",
      ],
      legend: {
        position: "bottom",
      },
      colors: ["#FF4560", "#008FFB", "#00E396", "#FEB019", "#775DD0"],
    },
  });
  const total = principalTotal + interestTotal;
  const interestPercentage = total ? ((interestTotal / total) * 100).toFixed(1) : 0;
  const principalPercentage = total ? ((principalTotal / total) * 100).toFixed(1) : 0;
  return (
    <>
      <section className="Pie_chart_holder">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div id="chart">
              <PieChart
                series={[
                  {
                    data: [
                      { id: 0, value: interestTotal, label: `Total Interest(${interestPercentage})%` },
                      { id: 1, value: principalTotal, label: `Principle Loan Amount(${principalPercentage})%` },
                      
                    ],
                  },
                ]}
                width={700}
                height={200}
              />
            </div>
          </div>

          {/* <div className="col-md-6 col-sm-5">
            <div className="chart_info_div">
              <div className="slice_div slice_1_div">
                <div className="box_holder">
                  <div className="first_box"></div>
                  <div className="second_box">
                    <p className="percent">39.6%</p>
                  </div>
                </div>
                <p className="label">Total Interest</p>
              </div>

              <div className="slice_div slice_2_div">
                <div className="box_holder">
                  <div className="first_box"></div>
                  <div className="second_box">
                    <p className="percent">60.6%</p>
                  </div>
                </div>
                <p className="label">Principal Loan Amount</p>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Pei_chart_holder;
